import { render, staticRenderFns } from "./PixAutomatico.vue?vue&type=template&id=24ed0d03&scoped=true"
import script from "./PixAutomatico.vue?vue&type=script&lang=ts"
export * from "./PixAutomatico.vue?vue&type=script&lang=ts"
import style0 from "./PixAutomatico.vue?vue&type=style&index=0&id=24ed0d03&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ed0d03",
  null
  
)

export default component.exports